import Courses from "./Courses";

// Preserve /courses/filter and its existing q=views / q=averageRating links.
export default Courses;
